/**
 * Curated timezone list for the provisioning wizard.
 *
 * Showing all ~400 IANA timezones in a <select> is unwieldy. This is
 * the short list of common business timezones across regions, with an
 * "Other..." sentinel that flips the field into a free-text input —
 * any IANA name is accepted by the backend (`tenantConfigSchema`
 * validates non-empty, not against the enumerated list, on purpose).
 *
 * When this list outgrows usefulness (rare timezones reported by
 * customers) we switch to a typeahead over the full Intl-provided
 * supportedValuesOf('timeZone') list. Until then, curated.
 */
export const TIMEZONE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'America/Los_Angeles', label: 'Los Angeles (PT)' },
  { value: 'America/Denver',      label: 'Denver (MT)' },
  { value: 'America/Chicago',     label: 'Chicago (CT)' },
  { value: 'America/New_York',    label: 'New York (ET)' },
  { value: 'America/Sao_Paulo',   label: 'São Paulo' },
  { value: 'UTC',                 label: 'UTC' },
  { value: 'Europe/London',       label: 'London' },
  { value: 'Europe/Paris',        label: 'Paris / Berlin' },
  { value: 'Africa/Johannesburg', label: 'Johannesburg' },
  { value: 'Asia/Dubai',          label: 'Dubai' },
  { value: 'Asia/Kolkata',        label: 'Kolkata (IST)' },
  { value: 'Asia/Singapore',      label: 'Singapore' },
  { value: 'Asia/Tokyo',          label: 'Tokyo' },
  { value: 'Australia/Sydney',    label: 'Sydney' },
];

export const OTHER_TIMEZONE_SENTINEL = '__other__';

export const LOCALE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'en',    label: 'English (en)' },
  { value: 'en-GB', label: 'English, UK (en-GB)' },
  { value: 'es',    label: 'Spanish (es)' },
  { value: 'fr',    label: 'French (fr)' },
  { value: 'de',    label: 'German (de)' },
  { value: 'pt-BR', label: 'Portuguese, Brazil (pt-BR)' },
  { value: 'ja',    label: 'Japanese (ja)' },
];
